import { PaymentConnectorInterface } from '@/services/connectors/interfaces';
import { AxiosResponse } from 'axios';
import PaymentMethodLiteral from '@/utils/paymentMethodLiteral';
import { FormDataToken } from '@/models/BaseTypes';
import {
  PaymentRequest,
  PaymentUrlResponse,
} from '@/models/PaymentServiceRequest';

export class PaymentConnectorStub implements PaymentConnectorInterface {
  checkIbanSwift(iban: string, swift: string): Promise<AxiosResponse> {
    console.log('Checking IBAN Data:');
    console.dir({ iban, swift });

    const result = {
      checkFailed: false,
      knownBySAP: false,
      bankName: 'Musterbank im Park',
      ibanError: false,
    };

    if (iban.toLowerCase().includes('fail')) {
      result.checkFailed = true;
    }
    if (iban.toLowerCase().includes('error')) {
      result.ibanError = true;
    }
    return new Promise<AxiosResponse>((resolve) => {
      setTimeout(() => {
        resolve({ data: result } as AxiosResponse);
      }, 500);
    });
  }

  getPayOneParameters(
    formDataToken: FormDataToken | null,
  ): Promise<AxiosResponse> {
    console.log('Fetching stubbed PayOne parameters:');
    console.dir(formDataToken);

    const result = {
      mode: 'test',
      aid: '40364',
      mid: '40031',
      portalid: '2028806',
      api_version: '3.11',
      request: 'creditcardcheck',
      encoding: 'UTF-8',
      responsetype: 'JSON',
      storecarddata: 'yes',
      hash: 'dd979a05ad84a054c9f252872afbd231f610045010fcfe85a2149df2207b77c50679b2c9b2098388865bbb5775910157',
    };

    return new Promise<AxiosResponse>((resolve) => {
      setTimeout(() => {
        resolve({ data: result } as AxiosResponse);
      }, 500);
    });
  }

  getPaymentAuthorizationUrl(
    data: PaymentRequest,
    formDataToken: FormDataToken | null,
  ): Promise<PaymentUrlResponse> {
    console.log('Get stubbed payment authorization URL for data:');
    console.dir(data);
    console.dir(formDataToken);

    return new Promise<PaymentUrlResponse>((resolve) => {
      setTimeout(() => {
        resolve({
          status: 'REDIRECT',
          externalRedirectUrl:
            'https://threedssvc.pay1.de/3ds/3ds2/device/502b4887-e4f1-4fab-97d5-017be6472c47',
          ctxToken: '8olmw0XCe5V8orfptPV2MnbBMrbsub',
        });
      }, 500);
    });
  }

  getBillingFrequencies(
    salesCampaignId: string,
    paymentMethod: PaymentMethodLiteral,
  ): Promise<AxiosResponse> {
    console.log('Fetching stubbed billing frequencies:');
    console.dir({ salesCampaignId, paymentMethod });
    return new Promise<AxiosResponse>((resolve) => {
      setTimeout(() => {
        resolve({
          data: [
            {
              code: '01',
              name: 'Jährlich',
              discountDomestic: -4,
              discountAbroad: -4,
            },
            {
              code: '02',
              name: 'Halbjährlich',
              discountDomestic: -2,
              discountAbroad: -2,
            },
            {
              code: '04',
              name: 'Vierteljährlich',
              discountDomestic: 0,
              discountAbroad: 0,
            },
            {
              code: '12',
              name: 'Monatlich',
              discountDomestic: 0,
              discountAbroad: 0,
            },
          ],
        } as AxiosResponse);
      }, 500);
    });
  }
}
